import './App.css'
import Header from './Header'
import './Header.css'
import Content from './Content'
import './Content.css'
import Footer from './Footer'
import './Footer.css'

function App() {

  return (
    <div>
      <Header />
      <Content />
      <Footer />
    </div>
  )
}

export default App